// src/components/SkeletonLoader.tsx
import React from 'react';
import { Skeleton, Card, Row, Col } from 'antd';

interface SkeletonLoaderProps {
  type?: 'table' | 'card' | 'list' | 'chart' | 'dashboard';
  rows?: number;
}

export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ type = 'card', rows = 3 }) => {
  if (type === 'table') {
    return (
      <div>
        <Skeleton active paragraph={{ rows: 0 }} />
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} active paragraph={{ rows: 0 }} style={{ marginTop: 16 }} />
        ))}
      </div>
    );
  }

  if (type === 'list') {
    return (
      <div>
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} active avatar paragraph={{ rows: 2 }} style={{ marginBottom: 16 }} />
        ))}
      </div>
    );
  }

  if (type === 'chart') {
    return (
      <Card>
        <Skeleton active paragraph={{ rows: 0 }} />
        <div style={{ height: 400, marginTop: 20 }}>
          <Skeleton.Image style={{ width: '100%', height: '100%' }} />
        </div>
      </Card>
    );
  }

  if (type === 'dashboard') {
    return (
      <Row gutter={[16, 16]}>
        {Array.from({ length: 4 }).map((_, i) => (
          <Col xs={24} sm={12} md={6} key={i}>
            <Card>
              <Skeleton active paragraph={{ rows: 1 }} />
            </Card>
          </Col>
        ))}
      </Row>
    );
  }

  // Default: card
  return (
    <Card>
      <Skeleton active avatar paragraph={{ rows }} />
    </Card>
  );
};
